import { Flex, View, Heading, Link } from "@aws-amplify/ui-react";

import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <View>
      <Helmet>
        <title>Routines</title>
      </Helmet>
      <Flex marginTop={"1rem"}>
        <Heading level={1}>Not Found</Heading>
      </Flex>
      <Flex marginTop={"1rem"}>
        <Link onClick={() => navigate(-1)}>Back</Link>
      </Flex>
    </View>
  );
}
